

var _squid = require('squid');

require('./directive');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BmlSignatureRoute', function () {
    return _squid.$ComponentRoute.extend('BmlSignatureRoute', {

        name: 'bmlsignature',
        trackingData: {
            fptiState: 'ppc_signature',
            buzname: {
                'fullpage': {
                    'pagename': '%::ppc_signature',
                    'pagename2': '%::ppc_signature:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },
        titleContent: 'consumerCreditInfo.applicationApprovedMessage',
        directive: 'xo-bml-signature-page',

        children: []

    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/route.js
// module id = ../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/route.js
// module chunks = 0